import React, {
    useState,
    useEffect,
    useContext,
    useRef
} from 'react';
/**
 * import style files
 */
import './GameImprovementsWrap.css';

/**
 * import components
 */
import { SearchGames } from '../SearchGames/SearchGames';
import { WinnersGame } from '../WinnersGame/WinnersGame';
import { RecommendedGames } from '../RecommendedGames/RecommendedGames';

import {
    AsgAppContext,
    AsgFwContext
} from '../../contexts';
import { useSelector } from 'react-redux';

/**
 * Parent Game Improvements components
 * @return {JSX.Element}
 * @constructor
 */
export const GameImprovementsWrap = ({ gamesListItem, onMobile }) => {
    const AsgFW = useContext(AsgFwContext);
    const AsgApp = useContext(AsgAppContext);
    const wrapperEl = useRef(null);

    const [mobilePanelOpenStatus, setMobilePanelOpenStatus] = useState(true);
    const [searchOpenStatus, setSearchOpenStatus] = useState(false);
    const [winnersOpenStatus, setWinnersOpenStatus] = useState(false);
    const [recommendedOpenStatus, setRecommendedOpenStatus] = useState(false);
    const [recentGames, setRecentGames] = useState([]);
    const { showWinnerTicker } = useSelector(state => state.app.config);

    useEffect(() => {
        setMobilePanelOpenStatus(!onMobile);

        window.addEventListener('blur', () => {
            if (document.activeElement.tagName === 'IFRAME') {
                resetActiveFromAll();
            }
        });

        document.addEventListener('click', (e) => {
            closeWidgetOnClickOutside(e.target);
        });

        $(document).on('startInGame', () => {
            resetActiveFromAll();
            $('body').removeClass('pass-trough-game');
        });
        return () => {
            window.removeEventListener('blur', () => {
                if (document.activeElement.tagName === 'IFRAME') {
                    resetActiveFromAll();
                }
            });
            document.body.removeEventListener('click', closeWidgetOnClickOutside);
            $(document).on('startInGame', () => {
                $('body').removeClass('pass-trough-game');
            });
        };

    }, []);

    useEffect(() => {
        if (searchOpenStatus) {
            AsgFW.getRecentGames((data) => {
                getRecent(data);
            });
        }
    }, [searchOpenStatus]);

    const getRecent = (data) => {
        let recentGamesList = [];
        data.forEach((value) => {
            let temp = AsgFW.getGameById(value.gameId);
            if (temp) {
                recentGamesList.push(temp);
            }
        });
        setRecentGames(recentGamesList);
    };
    const handleMobilePanelOpenStatus = () => {
        setMobilePanelOpenStatus(!mobilePanelOpenStatus);
        AsgApp.closeWalkThroughIfOpen();
        if (document && document.querySelector('.game-improvements-component-overly')) {
            if (!mobilePanelOpenStatus) {
                document.querySelector('.game-improvements-component-overly').classList.add('active');
            } else {
                document.querySelector('.game-improvements-component-overly').classList.remove('active');
            }
        }
    };

    const closeWidgetOnClickOutside = (e) => {
        if (wrapperEl.current && !wrapperEl.current.contains(e)) {
            resetActiveFromAll();
        }
    };

    const resetActiveFromAll = () => {
        setSearchOpenStatus(false);
        setWinnersOpenStatus(false);
        setRecommendedOpenStatus(false);
    };

    const handleSearchOpenStatus = () => {
        resetActiveFromAll();
        setSearchOpenStatus(!searchOpenStatus);
        AsgApp.closeWalkThroughIfOpen();
    };

    const handleRecommendedOpenStatus = () => {
        resetActiveFromAll();
        setRecommendedOpenStatus(!recommendedOpenStatus);
        AsgApp.closeWalkThroughIfOpen();
    };

    const handleWinnersOpenStatus = () => {
        resetActiveFromAll();
        setWinnersOpenStatus(!winnersOpenStatus);
        AsgApp.closeWalkThroughIfOpen();
    };

    const mobileStatusClass = mobilePanelOpenStatus ? ' open' : ' close';
    return (
        <div>
            {
                mobilePanelOpenStatus &&
                    <div className="components-wrapper" ref={wrapperEl}>
                        <SearchGames
                            gamesListItem={gamesListItem}
                            recentGames={recentGames}
                            searchOpenStatus={searchOpenStatus}
                            changeStatus={handleSearchOpenStatus}
                            changeMobilePanelOpenStatus={handleMobilePanelOpenStatus}
                        />
                        {showWinnerTicker && <WinnersGame
                            gamesListItem={gamesListItem}
                            winnersOpenStatus={winnersOpenStatus}
                            changeStatus={handleWinnersOpenStatus}
                            changeMobilePanelOpenStatus={handleMobilePanelOpenStatus}
                        />}
                        <RecommendedGames
                            recommendedOpenStatus={recommendedOpenStatus}
                            changeStatus={handleRecommendedOpenStatus}
                            changeMobilePanelOpenStatus={handleMobilePanelOpenStatus}
                        />
                    </div>
            }

            {onMobile && <div
                onClick={handleMobilePanelOpenStatus}
                className={`game-improvements-mobile-burger ${mobileStatusClass}`
                }
            > </div>
            }
        </div>
    );
};
